import { ClubLinkButton } from './ClubButton'
import { EmptyPlate } from './EmptyPlate'

interface SignInPromptProps {
  /** What signing in would reveal here, e.g. "your standing". */
  what: string
  className?: string
}

/**
 * What a member area shows a visitor who isn't signed in.
 *
 * The clubhouse is deliberately browsable by anyone — the rooms, the chrome
 * and the furniture are all public — so this stands in only for the part that
 * is genuinely personal. It never pretends there is data behind the door.
 */
export function SignInPrompt({ what, className }: SignInPromptProps) {
  return (
    <EmptyPlate
      className={className}
      title="You're a guest of the club."
      description={`Sign in to see ${what}. Anyone may look about; only members keep a card.`}
      action={
        <ClubLinkButton to="/sign-in" variant="ghost" size="sm">
          Sign in
        </ClubLinkButton>
      }
    />
  )
}
